@if (showLoader) {
  <div class="loader-container">
    <ng-lottie [options]="options" class="lottie-animation"></ng-lottie>
  </div>
}
